const HOURS = 60 * 60 * 1000;
const isDevelopment = process.env.NODE_ENV === "development";
const resolverEndpointFromEnv = process.env.REACT_APP_SC_CLIENT_ID_ENDPOINT || "";
const apiEndpointFromEnv = process.env.REACT_APP_SC_API_ENDPOINT || "";
const hasMissingRequiredProductionEnv =
  !isDevelopment && (!resolverEndpointFromEnv || !apiEndpointFromEnv);

const soundcloudConfig = Object.freeze({
  HAS_MISSING_REQUIRED_PRODUCTION_ENV: hasMissingRequiredProductionEnv,
  CLIENT_ID_INTERNAL_ENDPOINT:
    resolverEndpointFromEnv || "/internal/sc/client-id",
  API_INTERNAL_ENDPOINT:
    apiEndpointFromEnv || "/internal/sc-api",
  CLIENT_ID_CACHE_KEY: "sc_client_id_cache_v1",
  CLIENT_ID_CACHE_TTL_MS: 5 * HOURS,
  CLIENT_ID_REGEX: /[a-zA-Z0-9]{20,40}/,
  FETCH_TIMEOUT_MS: 12000,
  CLIENT_ID_ENV_FALLBACK: process.env.REACT_APP_SOUNDCLOUD_CLIENT_ID || "",
});

export default soundcloudConfig;
